/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_TeamInputs */

const th_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงทะเบียนทีม`)
};

const en_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register team`)
};

const ja_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを登録`)
};

const zh_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名球队`)
};

const es_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscribir equipo`)
};

const pt_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrever time`)
};

const id_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftarkan tim`)
};

const fr_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrire l’équipe`)
};

const tl_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magrehistro ng team`)
};

const vi_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký đội`)
};

const ko_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀 등록`)
};

const de_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team melden`)
};

const ru_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявить команду`)
};

const tr_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım kaydet`)
};

const it_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscrivi la squadra`)
};

const pl_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoś drużynę`)
};

const uk_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявити команду`)
};

const hi_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम पंजीकृत करें`)
};

const ar_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل فريق`)
};

const ms_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftarkan pasukan`)
};

const bn_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল নিবন্ধন করুন`)
};

const zh_tw2_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名球隊`)
};

const zh_hk2_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名球隊`)
};

const ur_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم رجسٹر کریں`)
};

const fa_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت تیم`)
};

const sw_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sajili timu`)
};

const nl_register_team = /** @type {(inputs: Register_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team inschrijven`)
};

/**
* | output |
* | --- |
* | "Register team" |
*
* @param {Register_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const register_team = /** @type {((inputs?: Register_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_register_team(inputs)
	if (locale === "ja") return ja_register_team(inputs)
	if (locale === "zh") return zh_register_team(inputs)
	if (locale === "es") return es_register_team(inputs)
	if (locale === "pt") return pt_register_team(inputs)
	if (locale === "id") return id_register_team(inputs)
	if (locale === "fr") return fr_register_team(inputs)
	if (locale === "tl") return tl_register_team(inputs)
	if (locale === "vi") return vi_register_team(inputs)
	if (locale === "ko") return ko_register_team(inputs)
	if (locale === "de") return de_register_team(inputs)
	if (locale === "ru") return ru_register_team(inputs)
	if (locale === "tr") return tr_register_team(inputs)
	if (locale === "it") return it_register_team(inputs)
	if (locale === "pl") return pl_register_team(inputs)
	if (locale === "uk") return uk_register_team(inputs)
	if (locale === "hi") return hi_register_team(inputs)
	if (locale === "ar") return ar_register_team(inputs)
	if (locale === "ms") return ms_register_team(inputs)
	if (locale === "bn") return bn_register_team(inputs)
	if (locale === "zh-TW") return zh_tw2_register_team(inputs)
	if (locale === "zh-HK") return zh_hk2_register_team(inputs)
	if (locale === "ur") return ur_register_team(inputs)
	if (locale === "fa") return fa_register_team(inputs)
	if (locale === "sw") return sw_register_team(inputs)
	if (locale === "nl") return nl_register_team(inputs)
	return en_register_team(inputs)
});